var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyberRangeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cyber-criminal 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9999 42.0184C7.31238 41.7767 8.1066 69.1214 5.30957 100.462H51.9999H98.6841C95.8932 69.1214 96.6874 41.7767 51.9999 42.0184Z",
    fill: "#2F5274"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9996 42.0185C39.7248 41.9556 30.8909 43.9706 24.46 47.574C25.825 50.239 27.9212 52.5891 30.6959 54.5351C36.6779 58.7377 44.7846 60.4034 51.9996 60.4034C59.2086 60.4034 67.3153 58.7398 73.2973 54.5351C76.072 52.5891 78.1743 50.239 79.5332 47.574C73.1084 43.9706 64.2704 41.9556 51.9996 42.0185Z",
    fill: "#2A4A68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9202 3.67661C34.4843 11.1902 29.3147 22.8902 26.3369 36.0466C19.969 64.1875 84.0305 64.1875 77.6625 36.0486C74.6807 22.8922 69.5152 11.1922 58.0752 3.67864C54.5043 1.32849 49.4891 1.32849 45.9202 3.67661Z",
    fill: "#2F5274"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9448 40.6433C27.0904 62.4203 75.9054 62.6499 78.0484 41.3279C77.5711 40.9988 77.3111 40.7632 77.3395 40.6596C64.7986 30.5846 38.504 30.5785 25.9448 40.6433Z",
    fill: "#1F364D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6623 35.9268C58.5853 32.2421 45.5162 32.1609 35.3071 35.6729C36.4243 44.4824 43.4728 51.277 51.9999 51.277C60.4459 51.277 67.4435 44.6165 68.6623 35.9268Z",
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6623 35.9268C58.5853 32.2421 45.5162 32.1609 35.3071 35.6729C35.6403 38.3277 36.5157 40.7916 37.8056 42.9448C40.8403 44.5799 43.6962 42.6116 46.5278 41.2466L48.4737 40.3143C50.7649 39.2093 53.1943 39.2093 55.4876 40.3143L57.4335 41.2466C60.2834 42.6177 63.1576 44.6043 66.2085 42.9224C67.4476 40.8384 68.3068 38.472 68.6623 35.9268Z",
    fill: "#231915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8181 33.3064C44.2912 33.5258 41.809 33.9158 39.4243 34.4866C39.6437 36.3472 41.226 37.7914 43.1435 37.7914C45.2113 37.7914 46.8871 36.1156 46.8871 34.0478C46.8871 33.7959 46.8628 33.5481 46.8181 33.3064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5185 34.6552C62.146 34.0499 59.6638 33.6254 57.143 33.3715C57.1024 33.5969 57.0801 33.8204 57.0801 34.0499C57.0801 36.1177 58.7559 37.7935 60.8237 37.7935C62.6863 37.7935 64.2301 36.4346 64.5185 34.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.418 62.3269H80.5815C81.4102 62.3269 82.1252 62.6377 82.6838 63.2491C83.2424 63.8585 83.4963 64.6019 83.4212 65.4246L80.358 100.462H23.6374L20.5743 65.4246C20.5052 64.6019 20.753 63.8585 21.3177 63.2491C21.8743 62.6377 22.5893 62.3269 23.418 62.3269Z",
    fill: "#EBF5FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9997 67.4396C58.9141 67.4396 64.5224 73.0418 64.5224 79.9622C64.5224 84.045 62.5642 87.6668 59.5417 89.9519V93.7524C59.5417 94.6278 58.8227 95.3469 57.9472 95.3469H46.0461C45.1706 95.3469 44.4577 94.6278 44.4577 93.7524V89.9519C41.4291 87.6668 39.4771 84.045 39.4771 79.9622C39.4771 73.0418 45.0853 67.4396 51.9997 67.4396Z",
    fill: "#FF4646"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.799 87.7135C51.2587 88.4224 50.239 88.5605 49.5301 88.0121C48.8151 87.4718 48.677 86.4521 49.2254 85.7432L50.302 84.3335C50.5153 84.0572 50.7915 83.8379 51.1145 83.6997C51.3907 83.5779 51.6954 83.5149 52.0022 83.5149C52.3068 83.5149 52.6075 83.5779 52.8837 83.6997C53.2067 83.8379 53.489 84.0572 53.7023 84.3335L54.7789 85.7432C55.3192 86.4521 55.1811 87.4697 54.4742 88.0121C53.7612 88.5585 52.7415 88.4204 52.1992 87.7135L52.0042 87.4535L51.799 87.7135ZM56.1926 95.349H52.9386V92.1254C52.9386 91.2336 53.6698 90.5024 54.5615 90.5024C55.4593 90.5024 56.1906 91.2336 56.1906 92.1254V95.349H56.1926ZM51.0556 95.349H47.8076V92.1254C47.8076 91.2336 48.5328 90.5024 49.4306 90.5024C50.3284 90.5024 51.0536 91.2336 51.0536 92.1254V95.349H51.0556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8591 82.0829C48.478 82.0829 49.7962 80.7646 49.7962 79.1457C49.7962 77.5268 48.478 76.2085 46.8591 76.2085C45.2402 76.2085 43.9219 77.5268 43.9219 79.1457C43.9219 80.7646 45.2402 82.0829 46.8591 82.0829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1349 82.0829C58.7579 82.0829 60.0782 80.7646 60.0782 79.1457C60.0782 77.5268 58.7599 76.2085 57.1349 76.2085C55.516 76.2085 54.1978 77.5268 54.1978 79.1457C54.1978 80.7646 55.5181 82.0829 57.1349 82.0829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1.625 102.085C0.725156 102.085 0 101.359 0 100.462C0 99.5638 0.725156 98.8386 1.62297 98.8386H102.375C103.267 98.8386 103.998 99.5638 103.998 100.462C103.998 101.359 103.267 102.085 102.375 102.085H1.625Z",
    fill: "#0593FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5381 98.8366L23.6192 65.4246C23.544 64.6019 23.798 63.8585 24.3565 63.2491C24.9151 62.6397 25.6281 62.3269 26.4589 62.3269H23.4181C22.5894 62.3269 21.8744 62.6377 21.3158 63.2491C20.7511 63.8585 20.5033 64.6019 20.5723 65.4246L23.4973 98.8366H26.5381Z",
    fill: "#D4DDE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1635 79.9622C41.1635 73.3282 46.3168 67.8986 52.8411 67.468C52.5649 67.4457 52.2825 67.4396 52.0002 67.4396C45.0858 67.4396 39.4775 73.0418 39.4775 79.9622C39.4775 84.045 41.4296 87.6668 44.4582 89.9519V93.7524C44.4582 94.6278 45.1711 95.3469 46.0466 95.3469H47.7346C46.8591 95.3469 46.14 94.6278 46.14 93.7524V89.9519C43.1155 87.6668 41.1635 84.045 41.1635 79.9622Z",
    fill: "#E63F3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8197 79.1457C44.8197 77.6771 45.8962 76.4563 47.308 76.239C47.1637 76.2228 47.0134 76.2106 46.8591 76.2106C45.2361 76.2106 43.9219 77.5228 43.9219 79.1478C43.9219 80.7728 45.2341 82.0849 46.8591 82.0849C47.0155 82.0849 47.1637 82.0728 47.308 82.0504C45.8962 81.8351 44.8197 80.6143 44.8197 79.1457Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0976 79.1457C55.0976 77.6771 56.1803 76.4563 57.5899 76.239C57.4396 76.2228 57.2913 76.2106 57.1349 76.2106C55.516 76.2106 54.1978 77.5228 54.1978 79.1478C54.1978 80.7728 55.516 82.0849 57.1349 82.0849C57.2913 82.0849 57.4396 82.0728 57.5899 82.0504C56.1803 81.8351 55.0976 80.6143 55.0976 79.1457Z",
    fill: "#E6E6E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberRangeIcon);
export default __webpack_public_path__ + "static/media/CyberRangeIcon.8be6be43df36be31cf0e261f290b7705.svg";
export { ForwardRef as ReactComponent };